import { Pipe, PipeTransform } from '@angular/core';
import { Source } from '../model/search-constants';

@Pipe({
  name: 'source',
  standalone: true
})
export class SourcePipe implements PipeTransform {

  transform(id: string): string {
    return sourceLabels[ id ] ?? sourceLabels[ toKebabCase(id) ] ?? id;
  }

}

function toKebabCase(value: string): string {
  return value?.toLowerCase().replace(/_/g, '-');
}

export const sourceLabels = {
  [ Source.CLOUD_LEARNING_CONTENT ]: 'Training',
  [ Source.DOC ]: 'Documentation',
  [ Source.DOWNLOAD_META ]: 'Downloads',
  [ Source.MARKETPLACE_ENTRY ]: 'Marketplace'
};
